import {
  paymentMethod as PaymentMethods,
  paymentType as PaymentTypes,
  paymentMode as PaymentModes,
  policyType as PolicyTypes,
  lookupsJson
} from '@ourbranch/lookups';

// Shared by the current-term and renewal payment-method selects so the two can't drift. A missing
// key renders an empty select rather than falling back, which stranded escrow-billed FarmHome (Z)
// policies: staff were told to change the payment method to drop the last mortgagee, and couldn't.
export const paymentMethodOptionsMap = {
  [PolicyTypes.Auto]: lookupsJson.autoPaymentMethod,
  [PolicyTypes.Home]: lookupsJson.homeownersPaymentMethod,
  [PolicyTypes.Condo]: lookupsJson.condoPaymentMethod,
  [PolicyTypes.Renters]: lookupsJson.rentersPaymentMethod,
  [PolicyTypes.Farm]: lookupsJson.farmPaymentMethod,
  [PolicyTypes.FarmHome]: lookupsJson.farmPaymentMethod,
  [PolicyTypes.FarmRental]: lookupsJson.farmPaymentMethod
};

export const daysOfMonth = Array.from({ length: 28 }, (_, day) => ({
  id: day + 1,
  value: `${day + 1}`
}));

export const maskingDots = '\u25CF\u25CF\u25CF\u25CF';

// Single source of truth for how each payment method constrains paymentType/paymentMode. Two callers
// share it so the rules can't drift: the payment-method sub-components enforce it on mount (via
// useNormalizePaymentMethod), and the Payment tab seeds its Formik initialValues from it so the form
// doesn't open pre-dirtied — the on-mount pass then finds nothing to change and the "Save changes"
// footer only shows on real edits (#32985).
export const getNormalizedBillingDefaults = ({ paymentMethod, paymentType, paymentMode, policyType }) => {
  // When paymentMethod is unset, mirror billing-details-form's `values.paymentMethod || defaultPaymentMethod`
  // render fallback so the seed matches whichever method component actually mounts.
  const effectiveMethod =
    paymentMethod || (policyType === PolicyTypes.Auto ? PaymentMethods.CreditCard : PaymentMethods.Escrow);

  switch (effectiveMethod) {
    case PaymentMethods.ACH:
      return {
        paymentType: paymentType === PaymentTypes.Escrow ? PaymentTypes.OneTime : paymentType,
        paymentMode: PaymentModes.Automated
      };
    case PaymentMethods.CreditCard:
      return { paymentType, paymentMode: PaymentModes.Automated };
    case PaymentMethods.Escrow:
      return { paymentType: PaymentTypes.Escrow, paymentMode: PaymentModes.Automated };
    case PaymentMethods.Direct:
      return { paymentType, paymentMode: PaymentModes.Direct };
    case PaymentMethods.BillToOther:
      return { paymentType: PaymentTypes.OneTime, paymentMode: PaymentModes.Direct };
    default:
      return { paymentType, paymentMode };
  }
};
